import { BaseVectorMap } from "../components/Map/BaseVectorMap";

export default function VectorMapPage() {
  return (
    <div style={{ width: "100%", height: 600 }} className="flex">
      <BaseVectorMap />
    </div>
  );
}
